import _ from 'underscore';
import classNames from 'classnames';
import React, { Fragment, useRef, useState, } from 'react';
import PropTypes from 'prop-types';

import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AddFilterButton } from '@bingads-webui/filter-commons';

import { getAssetLibraryFilterBarEditingStyle } from './style';

const EditingFilterBar = ({
  filters,
  focusedFilter,
  onRenderNewFilterContextMenu,
  onRenderFilter,
  onCloseClick,
  onResetClick,
  i18n,
  classes,
}) => {
  // if no editing filter, show new filter context menu
  const [showNewFilterContextMenu, setShowNewFilterContextMenu] = useState(!focusedFilter);
  const toggleContextMenu = () => setShowNewFilterContextMenu(!showNewFilterContextMenu);
  const dismissContextMenu = () => setShowNewFilterContextMenu(false);

  const getDivider = (index) => {
    if (index === filters.length - 1) {
      return null;
    }
    return (<span className="filter-list-divider" />);
  };

  const contextMenuTargetRef = useRef();

  return (
    <div className={classNames(classes.filterBarEditingContainer)}>
      <div className="filter-list-editing">
        {filters.map((filter, index) => (
          <Fragment key={`filter-${filter.id}`}>
            {onRenderFilter({
              filter,
              focused: focusedFilter && focusedFilter.id === filter.id,
              index,
              isLast: index === filters.length - 1,
              isFirst: index === 0,
            })}
            {getDivider(index)}
          </Fragment>
        ))}
        <div ref={contextMenuTargetRef}>
          <AddFilterButton i18n={i18n} isGrayCommandBar onClick={toggleContextMenu} />
        </div>
        {onRenderNewFilterContextMenu({
          target: contextMenuTargetRef,
          show: showNewFilterContextMenu,
          onDismiss: dismissContextMenu,
        })}
      </div>
      <div className="filter-bar-button-group">
        <Button
          onClick={onResetClick}
          className="filter-bar-button"
          aria-label={i18n.getString(_TL_('Reset filter to default state'))}
        >
          <Glyphicon glyph="ba-Refresh" />
          {i18n.getString(_TL_('Reset'))}
        </Button>
        <div className="filter-bar-divider" />
        <Button
          onClick={onCloseClick}
          className="filter-bar-cancel-button filter-bar-button"
          aria-label={i18n.getString(_TL_('Close filter panel'))}
        >
          <Glyphicon glyph="ba-Cancel" />
        </Button>
      </div>
    </div>
  );
};

EditingFilterBar.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  focusedFilter: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onRenderNewFilterContextMenu: PropTypes.func,
  onRenderFilter: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func,
  onResetClick: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    filterBarEditingContainer: PropTypes.string,
  }).isRequired,
};

EditingFilterBar.defaultProps = {
  filters: [],
  focusedFilter: null,
  onRenderNewFilterContextMenu: () => null,
  onCloseClick: _.noop,
  onResetClick: _.noop,
};

export const AssetLibraryEditingFilterBar
  = React.memo(withDefaultStyles(EditingFilterBar, getAssetLibraryFilterBarEditingStyle));
